// extracted by mini-css-extract-plugin
export default {"sideMenuWrap":"side-menu_sideMenuWrap__C0Jpm"};